import SupportRegioneLombardiaView from "./SupportRegioneLombardiaView"

export default  SupportRegioneLombardiaView;
